// react-isomorphic-render uses `combineReducers` to merge all of these reducers.
// The keys exported will be used to namespace each reducer.
export { default as glowforgeStore } from '../store/reducers/glowforge-store';
export { default as common } from '../common/reducers/common';
export { default as onboarding } from './onboarding';
export { default as accountSettings } from './account-settings';
export { default as legal } from './legal';
export { default as company } from './company';
export { default as marketing } from './marketing';
export { default as account } from './account';
export { default as product } from './product';
export { default as landing } from './landing';
export { default as support } from './support';
export { reducer as form } from 'redux-form';
export { reducer as subscriptions } from './subscriptions';



// WEBPACK FOOTER //
// ./app/reducers/index.js